/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import { IFormImageLinks } from './types';

export enum EFormImageLinksFileds {
    INPUT = 'INPUT',
}

export const defaultFormImageLinksValues: IFormImageLinks = {
    [EFormImageLinksFileds.INPUT]: '',
};
